export default "__VITE_ASSET__DnapDccf__"